/**
 * Which design a visitor sees at a redesign URL. Phones get a mobile design built for them,
 * wider screens get the desktop one. `?m=<id>` shows a given mobile design (also on a wide
 * screen, for review) and `?view=desktop` forces the desktop design.
 */

export const PHONE_QUERY = '(max-width: 760px)';

export type View = { kind: 'desktop' } | { kind: 'mobile'; id: string };

export function pickView(search: string, isPhone: boolean, mobiles: string[], fallback: string): View {
  const params = new URLSearchParams(search);
  if (params.get('view') === 'desktop') return { kind: 'desktop' };
  const asked = params.get('m');
  if (asked && mobiles.includes(asked)) return { kind: 'mobile', id: asked };
  return isPhone ? { kind: 'mobile', id: fallback } : { kind: 'desktop' };
}
